var React = require('react');

function LinkedinIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zm-4 24h-3.6v-11.2h3.6v11.2zm-1.8-12.72c-1.151 0-1.92-.769-1.92-1.76 0-1.011.789-1.76 2.011-1.76s1.92.749 1.949 1.76c0 .991-.769 1.76-2.04 1.76zm14.4 12.72h-3.6v-6.24c0-1.44-.52-2.421-1.811-2.421-.988 0-1.569.661-1.829 1.301-.093.231-.12.549-.12.871v6.489h-3.6s.047-10.529 0-11.2h3.6v1.587c.479-.731 1.333-1.787 3.253-1.787 2.373 0 4.151 1.547 4.151 4.867v6.533z"}));
}

LinkedinIcon.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = LinkedinIcon;

LinkedinIcon.default = LinkedinIcon;
